import request from '@/utils/request'

/**
 * 获取默认场景列表
 */
export function getDefaultTopics() {
  return request({
    url: '/ai-dialog/topics',
    method: 'get'
  })
}

/**
 * 生成场景
 * @param {Object} data - 请求参数
 * @param {string} data.topic - 用户指定的话题关键词
 */
export function generateTopic(data) {
  return request({
    url: '/ai-dialog/generate-topic',
    method: 'post',
    data
  })
}

/**
 * 生成对话
 * @param {Object} data - 请求参数
 * @param {string} data.taskId - 任务ID
 * @param {string} data.userLevel - 用户等级
 * @param {Array} data.history - 对话历史
 * @param {Object} data.scene - 场景信息
 */
export function generateDialog(data) {
  return request({
    url: '/ai-dialog/generate-dialog',
    method: 'post',
    data
  })
}

/**
 * 生成推荐表达
 * @param {Object} data - 请求参数
 * @param {string} data.taskId - 任务ID
 * @param {string} data.userLevel - 用户等级
 * @param {Array} data.history - 对话历史
 * @param {Object} data.scene - 场景信息
 * @param {Array} data.indexArr - 请求系统生成推荐表达例句的索引
 * @param {string} data.count - 系统生成推荐表达例句的数量
 */
export function generateRecommendation(data) {
  return request({
    url: '/ai-dialog/generate-recommendation',
    method: 'post',
    data
  })
}

/**
 * 生成报告
 * @param {Object} data - 请求参数
 * @param {string} data.taskId - 任务ID
 * @param {string} data.userLevel - 用户等级
 * @param {Array} data.history - 对话历史
 * @param {Object} data.scene - 场景信息
 */
export function generateReport(data) {
  return request({
    url: '/ai-dialog/generate-report',
    method: 'post',
    data
  })
}
